import storeModule from '../store-module'
import { defineStore } from 'pinia'

export default defineStore('external-customers', storeModule.createStoreModule('external-customers'))
